module.exports = __webpack_public_path__ + "static/media/banner.e94b11ac.jpg";